import React from "react";
import { Box, Grid } from "@tiny/components";
import useBreakpoints from "@tiny/components/src/hooks/useBreakpoints";
import { useSuppressionSourceDetails } from "./SuppressionSourceDetails.hooks";
import SuppressionSourceDetailsHeader from "./SuppressionSourceDetailsHeader";
import { useRefresh } from "@tiny/components/src/RefreshProvider";
import useSuppressionImporter from "../../components/AddSuppressionDialog/useSupperessionImporter";
import SuppressionDetailsList from "../../components/SuppressionDetailsList";
import TinySuppressionImporter from "../../components/AddSuppressionDialog/TinySuppressionImporter";
import SuppressionDetailsStatistics from "../SuppressionDetailsStatistics";

function SuppressionSourceDetails({ suppressionId: suppressionIdProp }) {
  const { mdUp, lgUp } = useBreakpoints();

  const {
    suppressionImporterOpen,
    openSuppressionImporter,
    closeSuppressionImporter,
  } = useSuppressionImporter();

  const {
    suppressionDetails,
    suppressionId,
    refetchSegmentDetails,
    enableEdit,
    isSegmentLoading,
  } = useSuppressionSourceDetails(suppressionIdProp);

  const { refresh } = useRefresh();

  return (
    <>
      <Box overflow={{ xs: "hidden", lg: "initial" }}>
        <SuppressionSourceDetailsHeader
          onSaveTitle={refetchSegmentDetails}
          title={suppressionDetails?.name}
          suppressionId={suppressionId}
          segmentType={suppressionDetails?.segmentType}
          importDisabled={!enableEdit}
          onImport={openSuppressionImporter}
          enableEdit={!isSegmentLoading}
          suppressionScope={suppressionDetails?.scope}
        />
        <Grid container spacing={lgUp ? 5 : mdUp ? 4 : 2}>
          <Grid item xs={12}>
            <SuppressionDetailsStatistics
              suppressionDetails={suppressionDetails}
            />
          </Grid>
          <Grid item xs={12}>
            <SuppressionDetailsList
              pageName="SuppressionList"
              suppressionId={suppressionId}
              bgcolor="white"
              borderRadius={mdUp ? "8px" : "0px"}
              showChip
              onAfterDelete={refetchSegmentDetails}
              enableEdit={enableEdit}
            />
          </Grid>
        </Grid>
      </Box>
      <TinySuppressionImporter
        open={suppressionImporterOpen}
        onClose={closeSuppressionImporter}
        suppressionDetails={undefined}
        suppressionId={suppressionId}
        onSuccess={() => {
          console.log("Success!");
        }}
        suppressionType={suppressionDetails?.type}
      />
    </>
  );
}

export default SuppressionSourceDetails;
